// Libraries
import React from 'react';
import { useLazyQuery } from 'react-apollo';
import { get, join, capitalize } from 'lodash';
import { useHistory } from "react-router-dom";
import { loader } from 'graphql.macro';

// Config
import {
  ERROR_CONNECTION,
  MESSAGES_MAP
} from 'config';

// Types
import { SESSION_TYPE } from 'services/session';

// Data
import { COLUMNS, GET_ACTIONS_CELL } from './data';

// GraphQL
const pssQuery = loader('src/graphql/queries/pss.gql');

export type LIST_PROPS_TYPE = {
  session?: SESSION_TYPE,
  url: string
};

export const useList = ({
  session,
  url
}: LIST_PROPS_TYPE) => {
  const history = useHistory();
  const [data, setData] = React.useState([]);

  const columns = React.useMemo(
    () => COLUMNS,
    []
  );

  const [error, setError] = React.useState<string | boolean>(false);
  const [loading, setLoading] = React.useState<boolean>(false);

  const [
    handlepssQuery,
    {
      loading: pssQueryLoading,
      data: pssQueryData,
      error: pssQueryError
    }] = useLazyQuery(pssQuery, {
    fetchPolicy: 'no-cache'
  });

  const token = get(session, 'token');

  React.useEffect(() => {
    setLoading(!!pssQueryLoading);
  }, [pssQueryLoading]);

  React.useEffect((): any => {
    !!token && handlepssQuery();
  },[token]);

  React.useEffect((): any => {
    if (!pssQueryData || pssQueryLoading) {
      return;
    }
    const isError = get(pssQueryData, 'pss.__typename') === 'Error';
    const message = get(pssQueryData, 'pss.message');
    const normalizedData = get(pssQueryData, 'pss.data', []).map((pss: object) => ({
      ...pss,
      client: `${get(pss, 'client.surname', '')} ${capitalize(get(pss, 'client.name', '').substr(0,1))}. ${capitalize(get(pss, 'client.patronymic', '').substr(0,1))}.`,
      actions: GET_ACTIONS_CELL({
        ...pss,
        onEdit: () => history.push(`${url}/${get(pss, 'id')}`),
      })
    }));

    const dataError = isError && get(MESSAGES_MAP, `${message}`, message);
    const currentErrors = [
      ...(pssQueryError ? [ERROR_CONNECTION] : []),
      ...(dataError ? [dataError] : []),
    ];
    currentErrors.length > 0 ? setError(join(currentErrors, '\n')) : setData(normalizedData);

  }, [pssQueryData]);

  return {
    loading,
    error,
    data,
    columns,
  };
};

export default useList;
